import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

/* eslint-disable camelcase */
export type TranslationQueueStats = {
  pending_tasks_count: number;
  in_progress_tasks_count: number;
  failed_tasks_count: number;
  completed_tasks_count: number;
};
/* eslint-enable camelcase */

export type GetTranslationQueueStatsParams = {
  artistId?: string | null;
};

type TranslationQueueStatsResponse = ObjectResponse<TranslationQueueStats>;

export const getTranslationQueueStats = async ({
  artistId = null,
}: GetTranslationQueueStatsParams = {}): Promise<TranslationQueueStats> => {
  const params: Record<string, string> = {};

  if (artistId) {
    /* eslint-disable camelcase */
    params.artist_id = artistId;
    /* eslint-enable camelcase */
  }

  const url = `/web/studio/queues/stats`;
  const response = await api.executeGetRequest<TranslationQueueStatsResponse>(url, params);

  // Handle both possible response formats for backwards compatibility
  if (response.data && typeof response.data === 'object' && 'data' in response.data) {
    // Standard ObjectResponse format
    return response.data.data;
  }
  // Direct data format
  return response.data as unknown as TranslationQueueStats;
};
